<template>
  <div>
    <Header :notHome="true" @goScroll="goScroll"></Header>
    <pageNav :navList="navList" :current="currentActive" title="中心概况" @navClick="navClick"></pageNav>
    <div class="main-content-area">
      <!-- 中心简介 -->
      <div class="intro-area" ref="area0">
        <div class="intro-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>01.</span>
                    <span>中心简介</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="page-middle-content-row">
              <b-col xl="12" class="d-sm-none d-xl-block">
                <!-- pc -->
                <div class="intro-line flex justify-center">
                  <div class="intro-info">
                    <div class="top-label">
                      <span></span>
                    </div>
                    <div class="intro-btn flex align-center">
                      <div class="intro-btn-item" v-for="(item,index) in introList" :key="index" :class="{ 'intro-btn-active': introIndex == index }" @click="introBtnClick(index)">
                        {{ item.title }}</div>
                    </div>
                    <div class="intro-content ql-editor">
                      <div v-html="introList[introIndex]&&introList[introIndex].coreContent!=''?(introList[introIndex].coreContent):''" class="html-div"></div>
                    </div>
                    <div class="bottom-label">
                      <span></span>
                    </div>
                  </div>
                  <div class="intro-img  flex align-center justify-center">
                    <img :src="introList[introIndex]&&introList[introIndex].coreImage!=''?($BaseUrl+introList[introIndex].coreImage):'../../assets/image/img3.png'" />
                  </div>
                </div>
              </b-col>
              <b-col sm="12" class="d-sm-block d-xl-none sm-intro-col">
                <!-- h5 -->
                <div class="intro-line sm-intro-line flex- flex-column align-center">
                  <div class="intro-img flex align-center justify-center">
                    <img :src="introList[introIndex]&&introList[introIndex].coreImage!=''?($BaseUrl+introList[introIndex].coreImage):'../../assets/image/img3.png'" />
                  </div>
                  <div class="intro-info">
                    <div class="top-label">
                      <span></span>
                    </div>
                    <div class="intro-btn flex align-center">
                      <div class="intro-btn-item" v-for="(item,index) in introList" :key="index" :class="{ 'intro-btn-active': introIndex == index }" @click="introBtnClick(index)">
                        {{ item.title }}</div>
                    </div>
                    <div class="intro-content ql-editor">
                      <div v-html="introList[introIndex]&&introList[introIndex].coreContent!=''?(introList[introIndex].coreContent):''" class="html-div"></div>
                    </div>
                    <div class="bottom-label">
                      <span></span>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- 领导介绍 -->
      <div class="leader-area" ref="area1">
        <div class="leader-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>02.</span>
                    <span>领导介绍</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="specail-row page-middle-content-row">
              <b-col xl="3" sm="6" v-for="(item,index) in leaderList.slice((currentPage-1)*8,(currentPage-1)*8+8)" :key="item.leadersId" @click="openLeaderDetail(item)">
                <div class="leader-item flex flex-column justify-end align-start">
                  <div class="leader-img flex align-center justify-center">
                    <img :src="$BaseUrl+item.image" />
                  </div>
                  <div class="leader-content flex flex-column justify-between">
                    <div class="leader-name overHidden">
                      {{ item.name }}
                    </div>
                    <div class="leader-info">
                      <!-- <div>领导职务</div> -->
                      <div class="overHidden">{{ item.position }}</div>
                      <div class="overHidden2">{{item.remark}}</div>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col xl="3" sm="6" v-for="(item,ki) in (8-leaderList.slice((currentPage-1)*8,(currentPage-1)*8+8).length)" :key="(currentPage-1)*8+ki+99">
                <div class="pla-leader-item">
                </div>
              </b-col>
              <b-col sm="12" v-if="leaderList.length>8">
                <div class="flex align-center justify-center pageination">
                  <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="8" layout="pager,next" :total="leaderList.length">
                  </el-pagination>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- 产业布局 -->
      <div class="layout-area" ref="area2">
        <div class="layout-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>03.</span>
                    <span>产业布局</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="page-middle-content-row">
              <b-col :xl="12">
                <!-- pc -->
                <!-- class="d-sm-none d-xl-block" -->
                <div>
                  <div class="layout-line flex justify-center">
                    <img :src="$BaseUrl+compositeInfo.industryImage" class="layout-image">
                    <!-- <div v-for="(item, index) in layoutList" :key="index" class="layout-item flex align-center">
                    <div class="layout-content flex align-center" :class="getClass(item)">
                      {{ item.title }}
                    </div>
                    <img src="../../assets/image/icon13.png" v-if="index != layoutList.length - 1" />
                  </div> -->
                  </div>
                </div>
                <!-- h5 -->
                <!-- <div class="d-sm-block d-xl-none">
                <div class="sm-layout-line layout-line flex flex-column align-center">
                  <div v-for="(item, index) in layoutList" :key="index" class="layout-item flex flex-column align-center">
                    <div class="layout-content flex align-center justify-center" :class="getClass(item)">
                      {{ item.title }}
                    </div>
                    <img src="../../assets/image/icon13.png" v-if="index != layoutList.length - 1" />
                  </div>
                </div>
              </div> -->
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- 业务范围 -->
      <div class="service-area" ref="area3">
        <div class="service-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>04.</span>
                    <span>业务范围</span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="service-show-box page-middle-content-row">
          <b-container fluid>
            <b-row>
              <!-- pc -->
              <b-col xl="12" class="d-sm-none d-xl-block">
                <div class="service-show-line flex">
                  <div class="service-left flex align-end justify-end">
                    <div class=" flex align-center justify-end">
                      <div class="service-small-item" v-for="(item,index) in serviceList.slice(0,(serviceListIdx==0?0:serviceListIdx))||[]" :key="index+99">
                        <div class="service-small-item-img  flex align-center justiyf-center">
                          <img :src="$BaseUrl+item.image" />
                        </div>
                        <span>{{item.name}}</span>
                      </div>
                      <div class="service-left-icon" v-if="(serviceList.slice(0,(serviceListIdx==0?0:serviceListIdx))||[]).length!=0">
                        <img src="../../assets/image/icon16.png" @click="nextService(-1,serviceList[serviceListIdx])" />
                      </div>
                    </div>
                  </div>
                  <div class="service-model">
                    <div class="service-model-item">
                      <div class="service-model-top flex align-end">
                        <div class="service-info">
                          <div>{{ serviceList[serviceListIdx]?serviceList[serviceListIdx].name:'' }}</div>
                          <div class="service-btn-line flex align-center">
                            <div class="service-btn flex flex-column">
                              <el-popover placement="top-start" width="300" trigger="hover">
                                <div class="flex flex-column service-popover">
                                  <span>核心能力</span>
                                  <span>{{ serviceList[serviceListIdx]?(serviceList[serviceListIdx].coreContent):'' }}</span>
                                </div>
                                <div class="flex flex-column service-btn-content" slot="reference">
                                  <span>核心能力</span>
                                  <span class="overHidden2">{{ serviceList[serviceListIdx]?(serviceList[serviceListIdx].coreContent):'' }}</span>
                                </div>
                              </el-popover>
                            </div>
                            <div class="service-btn  flex flex-column">
                              <el-popover placement="top-start" width="300" trigger="hover">
                                <div class="flex flex-column service-popover">
                                  <span>业务方向</span>
                                  <span>{{ serviceList[serviceListIdx]?serviceList[serviceListIdx].direction:'' }}</span>
                                </div>
                                <div class="flex flex-column service-btn-content" slot="reference">
                                  <span>业务方向</span>
                                  <span class="overHidden2">{{ serviceList[serviceListIdx]?serviceList[serviceListIdx].direction:'' }}</span>
                                </div>
                              </el-popover>
                            </div>
                          </div>
                        </div>
                        <div class="service-model-icon flex align-center justify-center" v-if="(serviceList.slice(serviceListIdx+1)||[]).length!=0">
                          <img src="../../assets/image/icon15.png" @click="nextService(1,serviceList[serviceListIdx])" />
                        </div>
                      </div>
                      <div class="service-model-img flex align-center justify-center">
                        <img :src="$BaseUrl+(serviceList[serviceListIdx]?serviceList[serviceListIdx].image:'')" />
                      </div>
                    </div>
                  </div>
                  <div class="service-right flex">
                    <div class="service-small-item" v-for="(item,index) in serviceList.slice(serviceListIdx+1)||[]" :key="index+999">
                      <div class="service-small-item-img flex align-center justify-center">
                        <img :src="$BaseUrl+item.image" />
                      </div>
                      <span>{{item.name}}</span>
                    </div>
                  </div>
                </div>
              </b-col>
              <!-- h5 -->
              <b-col sm="12" class="d-sm-block d-xl-none service-sm-scroll">
                <el-carousel :interval="1000000" arrow="never" :autoplay="false" indicator-position="none" ref="swiper">
                  <el-carousel-item v-for="(item, index) in serviceList" :key="index">
                    <div class="sm-service-swiper flex justify-center">
                      <div class="service-swiper-item">
                        <div class="service-info">
                          <div>{{ item.name }}</div>
                          <div class="service-btn-line flex align-center">
                            <div class="service-btn flex flex-column">
                              <el-popover placement="top-start" width="300" trigger="click">
                                <div class="flex flex-column sm-service-popover">
                                  <span>核心能力</span>
                                  <span>{{ item.coreContent }}</span>
                                </div>
                                <div class="flex flex-column service-btn-content" slot="reference">
                                  <span>核心能力</span>
                                  <span class="overHidden2">{{ item. coreContent}}</span>
                                </div>
                              </el-popover>
                            </div>
                            <div class="service-btn  flex flex-column">
                              <el-popover placement="top-start" width="300" trigger="click">
                                <div class="flex flex-column sm-service-popover">
                                  <span>业务方向</span>
                                  <span>{{ item.direction }}</span>
                                </div>
                                <div class="flex flex-column service-btn-content" slot="reference">
                                  <span>业务方向</span>
                                  <span class="overHidden2">{{ item.direction }}</span>
                                </div>
                              </el-popover>
                            </div>
                          </div>
                        </div>
                        <div class="service-model-img flex align-center justify-center">
                          <img :src="$BaseUrl+item.image" />
                        </div>
                        <!-- <div class="service-model-icon"> -->
                        <div class="service-swiper-left" @click="smSwiperClick(0)">
                          <img src="../../assets/image/icon16.png" />
                        </div>
                        <div class="service-swiper-right" @click="smSwiperClick(1)">
                          <img src="../../assets/image/icon15.png" />
                        </div>
                        <!-- </div> -->
                      </div>

                    </div>
                  </el-carousel-item>
                </el-carousel>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- 发展规划 -->
      <div class="planning-area" ref="area4">
        <div class="planning-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>05.</span>
                    <span>发展规划</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="page-middle-content-row">
              <b-col xl="7">
                <div class="planning-img d-xl-block d-sm-none">
                  <img :src="(compositeInfo.developImage&&compositeInfo.developImage!='')?($BaseUrl+compositeInfo.developImage):'../../assets/image/img3.png'">
                </div>
                <div class="sm-planning-img d-xl-none d-sm-block">
                  <img :src="(compositeInfo.developImage&&compositeInfo.developImage!='')?($BaseUrl+compositeInfo.developImage):'../../assets/image/img3.png'">
                </div>
              </b-col>
              <b-col xl="5">
                <div class="planning-info">
                  <div class="top-label">
                    <span></span>
                  </div>
                  <div class="planning-info-content ql-editor">
                    {{ compositeInfo.developContent }}
                    <!-- <div v-html="compositeInfo.developContent" class="html-div"></div> -->
                  </div>
                  <div class="planning-item-line flex align-center">
                    <div v-for="(item, index) in (compositeInfo.aim||{}).target" :key="index" class="planning-item flex flex-column align-center">
                      <div class="planning-item-title">
                        <span>{{ item.num }}</span>
                        <span>{{ item.unit }}</span>
                      </div>
                      <el-popover placement="top-start" width="300" trigger="hover">
                        <div class="xl-planning-desc d-sm-none d-xl-block">
                          {{ item.describe }}
                        </div>
                        <div class="sm-planning-desc d-sm-block d-xl-none">
                          {{ item.describe }}
                        </div>
                        <div class="planning-desc overHidden2" slot="reference">
                          {{ item.describe }}
                        </div>
                      </el-popover>
                    </div>
                    <div class="planning-item flex flex-column align-center" v-for="(id) in 4-(((compositeInfo.aim||{}).target||[]).length)" :key="id+99"></div>
                  </div>
                  <div class="bottom-label">
                    <span></span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- 荣誉与成就 -->
      <div class="honor-area" ref="area5">
        <div class="honor-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>06.</span>
                    <span>荣誉与成就</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="page-middle-content-row">
              <!-- pc -->
              <b-col xl="12" class="d-sm-none d-xl-block xl-honor-scroll">
                <div v-for="(item,index) in honorListObj.pc" :key="`honor${index}`" @click="scrollclick($event)">
                  <vue-seamless-scroll :data="item" :class-option="defineScroll" :key="scrollViewKey">
                    <div class="honor-item-scroll flex">
                      <!-- <div class="flex flex-column"> -->
                      <div class="honor-scroll-item flex-column flex align-center" v-for="(item, index) in item" :key="index" :data="JSON.stringify(item)">
                        <div class="flex align-center justify-center">
                          <img :src="$BaseUrl+item.image" />
                        </div>
                        <span class="overHidden">{{ item.title }}</span>
                      </div>
                      <!-- </div> -->
                    </div>
                  </vue-seamless-scroll>
                </div>
                <!-- <div>
                <vueSeamlessScroll :data="honorList2" :class-option="defineScroll">
                  <div class="honor-item-scroll flex">
                    <div class="honor-scroll-item flex-column flex align-center" v-for="(item, index) in honorList2" :key="index">
                      <div>
                        <img src="../../assets/image/img3.png" />
                      </div>
                      <span class="overHidden">{{ item.title + '2-' + index }}</span>
                    </div>
                  </div>
                </vueSeamlessScroll>
              </div> -->
              </b-col>
              <!-- h5 -->
              <b-col sm="12" class="d-xl-none d-sm-block sm-honor-scroll">
                <el-carousel :interval="10000" arrow="never" indicator-position="inside">
                  <el-carousel-item v-for="(item, index) in honorListObj.h5" :key="index">
                    <div class="sm-honor-content flex justify-around">
                      <div class="honor-content-item flex-column flex align-center" v-for="(item, index) in item" :key="index" @click="goHonorDetail(item)">
                        <div class="flex align-center justify-center">
                          <img :src="$BaseUrl+item.image" />
                        </div>
                        <span class="overHidden">{{ item.title }}</span>
                      </div>
                      <div class="spe-content-item" v-if="item.length%2!=0"></div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!--社会责任 -->
      <div class="responsibility-area" ref="area6">
        <div class="responsibility-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="page-model-title-line flex justify-between align-center">
                  <div class="page-model-title">
                    <span>07.</span>
                    <span>社会责任</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="page-middle-content-row">
              <b-col xl="12">
                <div class="d-sm-none d-xl-block">
                  <div class="responsibility-line flex justify-center ">
                    <div class="responsibility-img flex align-center justify-center">
                      <img :src="(compositeInfo.societyImage&&compositeInfo.societyImage!='')?($BaseUrl+compositeInfo.societyImage):'../../assets/image/img3.png'" />
                    </div>
                    <div class="responsibility-info">
                      <div class="top-label">
                        <span></span>
                      </div>
                      <div class="responsibility-content ql-editort">
                        {{ compositeInfo.societyContent }}
                        <!-- <div class="html-div" v-html="compositeInfo.societyContent"></div> -->
                      </div>
                      <div class="bottom-label">
                        <span></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-xl-none d-sm-block">
                  <div class="sm-responsibility-line responsibility-line">
                    <div class="responsibility-img  flex align-center justify-center">
                      <img :src="(compositeInfo.societyImage&&compositeInfo.societyImage!='')?($BaseUrl+compositeInfo.societyImage):'../../assets/image/img3.png'" />
                    </div>
                    <div class="responsibility-info">
                      <div class="top-label">
                        <span></span>
                      </div>
                      <div class="responsibility-content">
                        {{compositeInfo.societyContent}}
                        <!-- <div class="html-div" v-html="compositeInfo.societyContent"></div> -->
                      </div>
                      <div class="bottom-label">
                        <span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <Footer @goScroll="goScroll"></Footer>
    <!-- 领导介绍 -->
    <el-dialog :visible.sync="visible" width="880px" :modal="false">
      <div class="d-xl-block d-sm-none">
        <div class="leader-detail-area flex">
          <div class="leader-left">
            <div class="leader-img">
              <img :src="$BaseUrl+visibleObject.image" />
            </div>
          </div>
          <div class="leader-right">
            <div class="leader-name">{{ visibleObject.name }}</div>
            <div class="leader-position">{{ visibleObject.position }}</div>
            <div class="leader-content">{{visibleObject.remark}}</div>
          </div>
        </div>
      </div>
      <div class="d-sm-block d-xl-none">
        <div class="sm-leader-detail-area">
          <div class="flex">
            <div class="leader-img">
              <img :src="$BaseUrl+visibleObject.image" />
            </div>
            <div class="leader-name">{{ visibleObject.name }}</div>
          </div>
          <div>
            <div class="leader-position">{{ visibleObject.position }}</div>
            <div class="leader-content">{{visibleObject.remark}}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { getCoreList } from "@/api/overview"
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      navList: [{
        title: '中心简介'
      }, {
        title: '领导介绍'
      }, {
        title: '产业布局'
      }, {
        title: '业务范围'
      }, {
        title: '发展规划'
      }, {
        title: '荣誉与成就'
      }, {
        title: '社会责任'
      }],
      // 中心简介
      introList: [],
      introIndex: 0,
      layoutList: [{
        title: '福州奇点星穹',
        class: 'red'
      }, {
        title: '福建省南平碳计量中心',
        class: 'red'
      }, {
        title: '福建省南平国碳创新研究院',
        class: 'red'
      }, {
        title: '福建武夷碳产业投资有限公司',
        class: 'black'
      }, {
        title: '福建空天碳智慧科技有限公司',
        class: 'black'
      }, {
        title: '福建瑞碳光电精密仪器有限公司',
        class: 'blue'
      }, {
        title: '福建福碳计量科技发展有限责任公司',
        class: 'blue'
      }, {
        title: '北京空天碳科技发展有限公司',
        class: 'blue'
      }, {
        title: '南平市延平区融拓数字产业有限公司',
      }, {
        title: '光泽空天碳数字科技有限公司',
      }],
      defineScroll: {
        step: 0.4, // 数值越大速度滚动越快
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动)direction => 0/1                                
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      },
      honorList: [{
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }, {
        title: '荣誉证书'
      }],
      honorList2: [
        {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }, {
          title: '荣誉证书'
        }
      ],
      currentActive: 0,
      serviceList: [],
      serviceListIdx: 0,
      leaderList: [],//领导介绍列表
      compositeInfo: {},//复合信息
      honorListObj: {
        pc: [],
        h5: []
      },
      servieListLength: 0,
      serviceTemp: 0,
      visible: false,
      visibleObject: {},
      topList: [],
      currentPage: 1,
      stopScroll: false,
      stopScrollTimeout: null,
      scrollViewKey: -1
    }
  },
  mounted() {
    this.countViewCount()
    this.getCore()
    window.addEventListener('resize', this.resizeRefreshScorllView);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener('resize', this.resizeRefreshScorllView);
  },
  methods: {
    getCore() {
      getCoreList().then(res => {
        // console.log(res)
        if (res.code == 200) {
          // 中心简介
          let obj = res.data.find(t => t.name == '中心简介') || { list: [[[]]] }
          this.introList = obj.list[0].map(v => {
            // v.coreContent='<p class="ql-bg-green ql-color-red">                  aaaaaaaaaaaaaaaaaa123451</p><p class="ql-size-large">                 bbbbbbbbbbbbbbbbbbbbbbb</p><p class="ql-align-right"> ccccccccccc</p>'
            v.coreContent = (v.coreContent || '').replace(/<img.*?>/g, "")
            return v
          })
          this.introIndex = 0
          // 领导介绍
          let obj2 = res.data.find(t => t.name == '领导介绍') || { list: [{}] }
          this.leaderList = obj2.list[0]
          // 中心概况中的产业布局，发展规划，社会责任
          let obj3 = res.data.find(t => t.name == '中心概况') || { list: [{}] }
          this.compositeInfo = obj3.list[0][0] || {}
          if (this.compositeInfo.aim) {
            this.compositeInfo.aim = JSON.parse(this.compositeInfo.aim)
          }
          // 服务范围
          let obj4 = res.data.find(t => t.name == '业务范围') || { list: [{}] }
          this.serviceList = [...obj4.list[0]]
          this.servieListLength = [...obj4.list[0]].length
          if (this.servieListLength < 9 && this.servieListLength > 0) {
            let i = 0
            while (this.serviceList.length < 9) {
              this.serviceList=this.serviceList.concat(this.serviceList).concat(this.serviceList)
              i=i+1
              // let tempI = (obj4.list[0].length - (i + 1))
              // this.serviceList.push(obj4.list[0][i])
              // this.serviceList.unshift(obj4.list[0][tempI])
              // if ((i + 1 <= (this.servieListLength - 1)) && ((obj4.list[0].length - (i + 2)) <= (this.servieListLength - 1))) {
              //   i = i + 1
              // }
            }
            this.serviceTemp = i
          }else{
            this.serviceList=this.serviceList.concat(this.serviceList).concat(this.serviceList)
            this.serviceTemp = 1
          }
          // this.serviceListIdx = this.serviceTemp
          this.serviceListIdx=this.servieListLength
          console.log('11111-')
          console.log(this.servieListLength)
          // 荣誉与成就
          this.honorListObj = {
            pc: [],
            h5: []
          }
          let obj5 = res.data.find(t => t.name == '荣誉与成就') || { list: [[]] }
          let temp = obj5.list[0]
          if (temp.length > 6) {
            if (temp.length > 12) {
              // pc
              this.honorListObj.pc.push(temp.slice(0, Math.ceil(temp.length / 2)))
              this.honorListObj.pc.push(temp.slice(Math.ceil(temp.length / 2)))
            } else {
              this.honorListObj.pc = [temp]
            }
            // h5
            let h5obj = temp.reduce((result, curV) => {
              if (result.last.length >= 6) {
                result.list.push(result.last)
                result.last = []
              }
              result.last.push(curV)
              return result
            }, { list: [], last: [] })
            if (h5obj.last.length != 0) {
              h5obj.list.push(h5obj.last)
            }
            this.honorListObj.h5 = h5obj.list
          } else {
            this.honorListObj.pc = [temp]
            this.honorListObj.h5 = [temp]
          }
          this.$nextTick(() => {
            if (this.$route.query.to != undefined) {
              this.navClick({ index: Number(this.$route.query.to) })
              setTimeout(() => {
                window.addEventListener("scroll", this.handleScroll)
              }, 1000)
            } else {
              window.addEventListener("scroll", this.handleScroll)
            }
          })
        }
      })
    },
    introBtnClick(index) {
      this.introIndex = index
    },
    navClick({ item, index }) {
      this.stopScroll = true
      if (this.stopScrollTimeout) clearTimeout(this.stopScrollTimeout)
      this.currentActive = index
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollByRef(`area${index}`)
        }, 100)
        this.stopScrollTimeout = setTimeout(() => {
          this.stopScroll = false
        }, 1100)
      })
    },
    getClass(item) {
      if (item.class) {
        return item.class
      }
      return ''
    },
    nextService(index, item) {
      let temp = this.serviceListIdx + index
      temp=temp%this.servieListLength
      this.serviceListIdx=temp+this.servieListLength
      // if ((temp - this.serviceTemp) < 0) {
      //   this.serviceListIdx = this.serviceList.length - 1 - this.serviceTemp
      // } else if ((temp - this.serviceTemp) > this.servieListLength - 1) {
      //   this.serviceListIdx = this.serviceTemp
      // } else {
      //   this.serviceListIdx = temp
      // }
    },
    smSwiperClick(index) {
      if (index == 1) {
        this.$refs.swiper.next()
      } else {
        this.$refs.swiper.prev()
      }
    },
    goScroll(index) {
      this.navClick({ index: Number(index) })
    },
    openLeaderDetail(item) {
      this.visibleObject = { ...item }
      this.visible = true
    },
    handleScroll(e) {
      if (this.stopScroll) {
        return
      }
      let nowTop = e.target.scrollTop || document.documentElement.scrollTop
      if (this.topList.length == 0) {
        for (let i = 0; i < 7; i++) {
          this.topList.push(this.$refs[`area${i}`].offsetTop - 200)
        }
      }
      let temp = this.currentActive
      let result = this.topList.reduce((res, curV, curVindex) => {
        if (nowTop >= curV) {
          res = curVindex
        }
        return res
      }, temp)
      // 获取距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 获取可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 获取滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + windowHeight >= scrollHeight) {
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部                    
        result = this.topList.length - 1
      }
      this.currentActive = result
      // console.log(this.topList)
    },
    handleCurrentChange(current) {
      this.currentPage = current
      this.topList = []
    },
    goHonorDetail(item) {
      this.$router.push({ path: '/newsDetail?contentId=' + item.contentId + '&type=honor&pageName=成就与荣耀&scroll=5' })
    },
    scrollclick(e) {
      const path = e.path || (e.composedPath && e.composedPath());
      let target = path.filter((r) => /honor-scroll-item/.test(r.className));
      if (target.length) target = target[0];
      else return;
      const data = JSON.parse(target.getAttribute("data")); // 单项数据详情
      this.goHonorDetail(data)
      // this.$emit("supervise-detail",data.name, data.type);
    },
    resizeRefreshScorllView() {
      this.scrollViewKey = Math.random()
    }
  }
}
</script>
<style lang="scss" scoped>
.top-label {
  margin-bottom: 15px;

  span {
    width: 154px;
    height: 8px;
    background: #1566d4;
    display: inline-block;
  }
}

.bottom-label {
  margin-top: 15px;
  text-align: right;

  span {
    // width: 116px;
    // height: 6px;
    width: 154px;
    height: 8px;
    background: #ffffff;
    display: inline-block;
  }
}

// 中心简介
.intro-area {
  background-image: url("../../assets/image/bg20.png");
  background-size: cover;
  width: 100%;
  min-height: 529px;
  padding-bottom: 60px;
  padding-top: 60px;
  .intro-box {
    max-width: 1200px;
    margin: 0 auto;

    .intro-line {
      margin-top: 30px;

      .intro-btn {
        margin-bottom: 15px;
        // overflow: auto;
        overflow: hidden;

        .intro-btn-item {
          padding: 8px 23px;
          background: #ffffff;
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          // font-size: 18px;
          font-size: 24px;
          color: #333333;
          line-height: 24px;
          user-select: none;
          cursor: pointer;
          flex-shrink: 0;
          // margin-left: 10px;
          margin-right: 15px;
        }
        .intro-btn-item:first-of-type {
          margin-left: 0;
        }

        .intro-btn-active {
          color: #fff;
          background-color: #1566d4;
        }
      }

      .intro-info {
        // width: 510px;
        width: 680px;
        min-height: 450px;
        background: rgba(255, 255, 255, 0.5);
        background-image: url("../../assets/image/bg16.png");
        z-index: 3;
        padding: 30px;
        background-size: cover;
        backdrop-filter: blur(10px);
        box-shadow: 0px 0 30px 0px rgba(10, 49, 128, 0.1);
        .intro-content {
          height: 300px;
          font-family: "SourceHanSansCN-Regular";
          overflow-y: auto;
          font-size: 20px;
          color: #666666;
          line-height: 30px;
        }

        ::-webkit-scrollbar {
          width: 3px;
          height: 0px;
        }

        /* 定义滚动条轨道 */
        ::-webkit-scrollbar-track {
          //   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
          border-radius: 2px;
          background-color: #fff;
        }

        /* 滑块 */
        ::-webkit-scrollbar-thumb {
          border-radius: 2px;
          -webkit-box-shadow: #1566d4;
          background-color: #1566d4;
        }
      }

      .intro-img {
        width: 680px;
        height: 383px;
        margin-top: -40px;
        margin-left: -180px;
        z-index: 2;
        position: relative;
        background: #fff;
        overflow: hidden;
        img {
          object-fit: cover;
          width: 680px;
          height: 383px;
        }
      }
    }

    .sm-intro-line {
      margin-top: 30px;

      .intro-img {
        // width: 750px;
        width: 100%;
        min-height: 423px;
        margin: 0 auto;
        z-index: 2;

        > img {
          object-fit: cover;
          width: 100%;
          min-height: 423px;
        }
      }

      .intro-info {
        // width: 702px;
        width: 93%;
        min-height: 465px;
        margin: 0 auto;
        margin-top: -50px;
        z-index: 3;
        position: relative;

        .intro-btn-item {
          min-width: 317px;
          text-align: center;
        }

        .intro-content {
          min-height: 254px;
        }
      }
    }
  }
}

// 领导介绍
.leader-area {
  background-image: url("../../assets/image/bg21.png");
  background-size: cover;
  width: 100%;
  min-height: 329px;
  padding-bottom: 60px;
  padding-top: 60px;
  .leader-box {
    max-width: 1200px;
    margin: 0 auto;
    .specail-row {
      > div {
        padding: 0;
        padding-right: 20px;
      }
      > div:nth-child(4),
      > div:nth-child(8) {
        padding: 0;
      }
    }
    .page-model-title-line {
      margin-bottom: 30px;
    }
    .leader-item {
      width: 100%;
      min-height: 280px;
      position: relative;
      margin-bottom: 15px;
      .leader-img {
        position: absolute;
        right: 0;
        top: 0px;
        width: 140px;
        height: 140px;
        background: linear-gradient(360deg, #c9c9c9 0%, #999999 100%);
        box-shadow: 0px 0px 20px 0px rgba(10, 49, 128, 0.2);
        // background: #fff;
        img {
          width: 140px;
          height: 140px;
          object-fit: cover;
        }
      }
      .leader-name {
        padding-top: 40px;
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        line-height: 36px;
        width: 53%;
      }
      .leader-content {
        width: 230px;
        min-height: 230px;
        background: #fff;
        border: 1px solid #e0e0e0;
        box-shadow: 0px 0 8px 0px rgba(26, 91, 255, 0.2);
        padding: 24px;
        user-select: none;
        background-image: url("../../assets/image/bg31.png");
        background-size: cover;
        .leader-info {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          line-height: 27px;
        }
      }
    }
    .pla-leader-item {
      width: 100%;
      min-height: 280px;
      margin-bottom: 15px;
    }
    .leader-item:hover {
      border-top: 6px solid #1566d4;
      animation-name: leaderItemBorderChange;
      animation-duration: 0.3s;
      animation-iterationcount: 1;
      .leader-img {
        top: 3px;
        animation-name: leaderItemImgChange;
        animation-duration: 0.3s;
        animation-iterationcount: 1;
        background: #fff;
      }
      .leader-name {
        color: #1566d4;
      }
      .leader-content {
        width: 100%;
        flex: 1;
        min-height: 0;
        animation-name: leaderItemChange;
        animation-duration: 0.3s;
        animation-iterationcount: 1;
      }
    }
  }
}
.pageination {
  /deep/.number {
    background: #fff !important;
    border: 1px solid rgba($color: #999, $alpha: 0.5) !important;
  }
  /deep/.active {
    border: none !important;
    color: #3b7af4 !important;
  }
}
/deep/.el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/deep/.el-dialog__header {
  padding: 0;
  .el-dialog__headerbtn {
    width: 40px;
    height: 40px;
    font-size: 40px;
  }
}
/deep/.el-dialog__body {
  padding: 60px 40px;
}
// 领导详情
.leader-detail-area {
  .leader-left {
    flex-shrink: 0;
    .leader-img {
      width: 160px;
      height: 160px;
      background: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(10, 49, 128, 0.2);
      background: linear-gradient(360deg, #c9c9c9 0%, #999999 100%);
      img {
        width: 160px;
        height: 160px;
        object-fit: cover;
      }
    }
  }
  .leader-right {
    flex: 1;
    min-width: 0;
    padding-left: 40px;
    .leader-name {
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 36px;
      color: #1566d4;
      line-height: 54px;
      margin-bottom: 70px;
    }
    .leader-position,
    .leader-content {
      font-family: "SourceHanSansCN-Regular";
      font-size: 18px;
      color: #333333;
      line-height: 27px;
    }
    .leader-position {
      margin-bottom: 15px;
    }
  }
}
.sm-leader-detail-area {
  > div:first-of-type {
    margin-bottom: 80px;
    .leader-img {
      width: 160px;
      height: 140px;
      background: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(10, 49, 128, 0.2);
      background: linear-gradient(360deg, #c9c9c9 0%, #999999 100%);
      img {
        width: 160px;
        height: 140px;
        object-fit: cover;
      }
    }
    .leader-name {
      font-family: "SourceHanSansCN-Regular";
      font-weight: bold;
      font-size: 48px;
      color: #1566d4;
      line-height: 72px;
      margin-left: 40px;
    }
  }
  > div:last-of-type {
    .leader-position,
    .leader-content {
      font-family: "SourceHanSansCN-Regular";
      font-size: 24px;
      color: #333333;
      line-height: 36px;
    }
    .leader-position {
      margin-bottom: 15px;
    }
  }
}
@keyframes leaderItemBorderChange {
  from {
    border-top: none;
  }
  30% {
    border-top: 6px solid rgba(21, 102, 212, 0.33);
  }
  60% {
    border-top: 6px solid rgba(21, 102, 212, 0.66);
  }
  90% {
    border-top: 6px solid rgba(21, 102, 212, 0.99);
  }
  to {
    border-top: 6px solid #1566d4;
  }
}
@keyframes leaderItemImgChange {
  from {
    top: 0;
  }
  33% {
    top: 1px;
  }
  66% {
    top: 2px;
  }
  to {
    top: 3px;
  }
}
@keyframes leaderItemChange {
  from {
    width: 80%;
    flex: 0;
  }

  16% {
    width: 83%;
    flex: 0.1;
  }

  33% {
    width: 87%;
    flex: 0.3;
  }

  48% {
    width: 90%;
    flex: 0.5;
  }

  66% {
    width: 93%;
    flex: 0.7;
  }

  84% {
    width: 96%;
    flex: 0.9;
  }

  to {
    width: 100%;
    flex: 1;
  }
}
// 产业布局
.layout-area {
  background-image: url("../../assets/image/bg18.png");
  background-size: cover;
  width: 100%;
  min-height: 632px;
  padding-bottom: 60px;
  padding-top: 60px;

  .layout-box {
    // max-width: 1080px;
    max-width: 1200px;
    margin: 0 auto;

    .page-model-title-line {
      margin-bottom: 30px;
    }
    .layout-line {
      img {
        width: 95%;
        // min-height: 500px;
        // object-fit: cover;
        // background: red;
      }
    }
    .layout-item {
      img {
        width: 31px;
        height: 31px;
        margin: 0 5px;
      }

      .layout-content {
        text-align: center;
        padding: 15px 10px;
        width: 60px;
        min-height: 520px;
        font-family: "SourceHanSansCN-Regular";
        font-weight: bold;
        font-size: 27px;
        color: #2299ff;
        line-height: 30px;
        background: rgba(255, 255, 255, 0.1);
        box-shadow: 0px 0 8px 0px rgba(26, 91, 255, 0.1);
        border: 2px solid #1566d4;
      }

      .red {
        color: #ff2323;
      }

      .black {
        color: #333333;
      }

      .blue {
        color: #1566d4;
      }
    }

    .sm-layout-line {
      .layout-item {
        width: 90%;
      }

      img {
        width: 31px;
        height: 31px;
        margin: 5px 0;
      }

      .layout-content {
        text-align: center;
        text-align: center;
        padding: 10px 15px;
        width: 100%;
        min-width: 100%;
        min-height: 60px;
        height: 60px;
      }
    }
  }
}
.service-popover {
  > span:first-of-type {
    font-family: "SourceHanSansCN-Regular";
    font-weight: bold;
    font-size: 15px;
    color: #1566d4;
    line-height: 23px;
  }
  > span:last-of-type {
    font-family: "SourceHanSansCN-Regular";
    font-size: 15px;
    color: #666666;
    line-height: 23px;
    font-weight: normal;
  }
}
.sm-service-popover {
  > span:first-of-type {
    font-family: "SourceHanSansCN-Regular";
    font-weight: bold;
    font-size: 20px;
    color: #1566d4;
    line-height: 30px;
  }
  > span:last-of-type {
    font-family: "SourceHanSansCN-Regular";
    font-weight: 400;
    font-size: 20px;
    color: #666666;
  }
}
// 业务范围
.service-area {
  background-image: url("../../assets/image/bg22.png");
  background-size: cover;
  width: 100%;
  min-height: 662px;
  padding-bottom: 60px;
  padding-top: 60px;
  .service-box {
    // max-width: 1080px;
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .service-show-box {
    max-width: 1440px;
    margin: 0 auto;
    overflow: hidden;
    .service-show-line {
      width: 100%;
      max-width: 1440px;
      .service-left,
      .service-right {
        flex: 1;
        min-width: 0;
        overflow: hidden;
      }
      .service-left {
        .service-left-icon {
          margin-left: 15px;
          img {
            width: 31px;
            height: 42px;
            cursor: pointer;
          }
        }
      }
      .service-model {
        flex-shrink: 0;
        position: relative;
        z-index: 3;
        width: 510px;
        .service-model-item {
          width: 435px;
          min-height: 525px;
          background-image: url("../../assets/image/bg23.png");
          background-size: cover;
          padding: 60px 35px;
          // border: 1px solid #333;
          background: rgba(255, 255, 255, 0);
          box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
          // backdrop-filter: blur(3px);
          .service-model-top {
            // position: relative;
            .service-info {
              width: 100%;
              > div:first-of-type {
                font-family: "SourceHanSansCN-Regular";
                font-weight: bold;
                font-size: 18px;
                color: #333333;
                line-height: 27px;
              }
              .service-btn-line {
                margin-top: 15px;
                width: 100%;
                .service-btn {
                  width: 48%;
                  padding: 15px 5px;
                  background: #ffffff;
                  margin-right: 15px;
                  border: 2px solid #1566d4;
                  min-height: 103px;
                  .service-btn-content {
                    > span:first-of-type {
                      font-family: "SourceHanSansCN-Regular";
                      font-weight: bold;
                      font-size: 15px;
                      color: #1566d4;
                      line-height: 23px;
                    }
                    > span:last-of-type {
                      font-family: "SourceHanSansCN-Regular";
                      font-size: 15px;
                      color: #666666;
                      line-height: 23px;
                      font-weight: normal;
                    }
                  }
                  > span:first-of-type {
                    font-family: "SourceHanSansCN-Regular";
                    font-weight: bold;
                    font-size: 15px;
                    color: #1566d4;
                    line-height: 23px;
                  }
                  > span:last-of-type {
                    font-family: "SourceHanSansCN-Regular";
                    font-size: 15px;
                    color: #666666;
                    line-height: 23px;
                  }
                }
              }
            }
            .service-model-icon {
              position: absolute;
              right: 0;
              top: 110px;
              img {
                width: 31px;
                height: 42px;
                cursor: pointer;
              }
            }
          }
        }
      }
      .service-model::before {
        position: absolute;
        width: 87px;
        height: 5px;
        background: #1566d4;
        top: 40px;
        content: "";
        left: 35px;
      }
      .service-model-img {
        width: 474px;
        height: 267px;
        margin-top: 17px;
        background: #fff;
        overflow: hidden;

        img {
          width: 474px;
          object-fit: cover;
          height: 267px;
        }
      }
      .service-right > .service-small-item {
        max-height: 236px;
      }
      .service-small-item {
        padding: 25px 15px;
        background-color: #fff;
        box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
        margin-left: 15px;
        .service-small-item-img {
          width: 256px;
          height: 144px;
          margin-bottom: 15px;
          background-color: #fff;
          overflow: hidden;
          > img {
            width: 256px;
            object-fit: cover;
            height: 144px;
          }
        }
        > span {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          // font-size: 18px;
          color: #333333;
        }
      }
    }
  }
  //   h5
  .service-sm-scroll {
    /deep/.el-carousel__container {
      min-height: 700px;
    }
  }
  .sm-service-swiper {
    width: 100%;
    .service-swiper-item {
      position: relative;
    }
    .service-swiper-left {
      position: absolute;
      left: -58px !important;
      top: 50%;
      margin-top: -19px;
      img {
        width: 38px;
        height: 38px;
      }
    }
    .service-swiper-right {
      position: absolute;
      right: -58px !important;
      top: 50%;
      margin-top: -19px;
      img {
        width: 38px;
        height: 38px;
      }
    }
    .service-swiper-item {
      width: 580px;
      min-height: 700px;
      background: url("../../assets/image/bg23.png");
      padding: 70px 20px;
      border: 1px solid #333;
      .service-info {
        position: relative;
        > div:first-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 26px;
          color: #1566d4;
          line-height: 27px;
        }
        .service-btn-line {
          margin-top: 20px;
          .service-btn {
            padding: 20px 10px;
            background: #ffffff;
            border: 3px solid #1566d4;
            width: 48%;
            min-height: 140px;
            .service-btn-content {
              > span:first-of-type {
                font-family: "SourceHanSansCN-Regular";
                font-weight: bold;
                font-size: 20px;
                color: #1566d4;
                line-height: 30px;
              }
              > span:last-of-type {
                font-family: "SourceHanSansCN-Regular";
                font-weight: 400;
                font-size: 20px;
                color: #666666;
              }
            }
            > span:first-of-type {
              font-family: "SourceHanSansCN-Regular";
              font-weight: bold;
              font-size: 20px;
              color: #1566d4;
              line-height: 30px;
            }
            > span:last-of-type {
              font-family: "SourceHanSansCN-Regular";
              font-weight: 400;
              font-size: 20px;
              color: #666666;
            }
          }
          .service-btn:first-of-type {
            margin-right: 20px;
          }
        }
      }
      .service-info::before {
        width: 154px;
        height: 8px;
        background: #1566d4;
        content: "";
        position: absolute;
        top: -30px;
        left: 0;
      }
      .service-model-img {
        width: 632px;
        height: 356px;
        margin-top: 20px;
        margin-left: -46px;
        background: #fff;
        img {
          width: 632px;
          object-fit: cover;
          height: 356px;
        }
      }
    }
  }
}

// 发展规划
.xl-planning-desc {
  font-size: 20px;
}
.sm-planning-desc {
  font-size: 24px;
}
.planning-area {
  background-image: url("../../assets/image/bg17.png");
  background-size: cover;
  width: 100%;
  min-height: 484px;
  padding-bottom: 60px;
  padding-top: 60px;

  .planning-box {
    // max-width: 1080px;
    max-width: 1200px;
    margin: 0 auto;

    .page-model-title-line {
      margin-bottom: 30px;
    }

    .planning-img {
      background: #fff;
      height: 383px;
      overflow: hidden;
      margin-right: 20px;
      img {
        max-width: 680px;
        width: 100%;
        object-fit: cover;
        height: 383px;
      }
    }
    .sm-planning-img {
      img {
        width: 100%;
      }
    }

    .planning-info-content {
      font-family: "SourceHanSansCN-Regular";
      height: 159px;
      overflow-y: auto;
      font-weight: 400;
      font-size: 20px;
      color: #666666;
      line-height: 30px;
      white-space: pre-wrap;
    }

    .planning-item-line {
      margin-top: 30px;

      .planning-item {
        flex: 1;
        flex-shrink: 0;

        .planning-item-title {
          > span:first-of-type {
            font-family: "SourceHanSansCN-Regular";
            font-weight: bold;
            font-size: 24px;
            color: #1566d4;
          }

          > span:last-of-type {
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            margin-left: 4px;
          }
        }

        .planning-desc {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 20px;
          color: #666666;
          line-height: 30px;
        }
      }
    }

    ::-webkit-scrollbar {
      width: 3px;
      height: 51px;
    }

    /* 定义滚动条轨道 */
    ::-webkit-scrollbar-track {
      //   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
      border-radius: 2px;
      background-color: #fff;
    }

    /* 滑块 */
    ::-webkit-scrollbar-thumb {
      border-radius: 2px;
      -webkit-box-shadow: #1566d4;
      background-color: #1566d4;
    }
  }
}

// 成就与荣誉
.honor-area {
  background-image: url("../../assets/image/bg19.png");
  background-size: cover;
  width: 100%;
  min-height: 324px; //524
  padding-bottom: 60px;
  padding-top: 60px;

  .honor-box {
    // max-width: 1080px;
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    .xl-honor-scroll {
      margin-top: 40px;
    }
    .honor-item-scroll {
      width: 100%;
      .honor-scroll-item {
        flex-shrink: 0;
        margin-right: 15px;
        margin-bottom: 15px;
        padding: 15px 15px 10px 15px;
        background: #fff;
        border: 1px solid #eee;

        > div {
          width: 180px;
          height: 101px;
          background: #fff;
          margin-bottom: 10px;
          img {
            width: 180px;
            object-fit: cover;
            height: 101px;
          }
        }

        > span {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          line-height: 27px;
        }
      }

      .honor-scroll-item:hover {
        background: #1566d4;

        > span {
          color: #fff;
        }
      }
    }

    .sm-honor-scroll {
      /deep/.el-carousel__container {
        min-height: 820px;
      }

      .sm-honor-content {
        flex-wrap: wrap;
        .honor-content-item {
          flex-shrink: 0;
          margin-right: 15px;
          margin-bottom: 15px;
          padding: 15px;
          background: #fff;
          border: 1px solid #eee;
          width: calc(50% - 15px);
          > div {
            width: 100%;
            max-width: 301px;
            height: 168px;
            img {
              width: 100%;
              max-width: 301px;
              object-fit: cover;
              height: 168px;
            }
          }

          > span {
            margin-top: 15px;
            font-family: "SourceHanSansCN-Regular";
            font-weight: bold;
            text-align: left;
            width: 100%;
            display: inline-block;
            font-size: 26px;
            color: #333333;
          }
        }
        .spe-content-item {
          background: transparent;
          width: calc(50% - 15px);
          margin-right: 15px;
          margin-bottom: 15px;
        }

        .honor-content-item:hover {
          background: #1566d4;

          > span {
            color: #fff;
          }
        }
      }

      ::v-deep .el-carousel__button {
        width: 50px;
        height: 6px;
        background: rgba(102, 102, 102, 0.5);
        border-radius: 3px;
        opacity: 1;
      }

      ::v-deep .is-active .el-carousel__button {
        background: #3b7af4 !important;
        opacity: 1;
      }
    }
  }
}

// 社会责任
.responsibility-area {
  background-image: url("../../assets/image/bg15.png");
  background-size: cover;
  width: 100%;
  min-height: 487px;
  padding-bottom: 60px;
  padding-top: 60px;

  .responsibility-box {
    // max-width: 1080px;
    max-width: 1200px;
    margin: 0 auto;

    .responsibility-line {
      margin-top: 40px;

      .responsibility-img {
        width: 680px;
        height: 383px;
        background-color: #fff;
        overflow: hidden;
        img {
          width: 100%;
          object-fit: cover;
          height: 383px;
        }
      }

      .responsibility-info {
        width: 680px;
        height: 450px;
        padding: 30px 30px;
        background: rgba(255, 255, 255, 0);
        box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
        background-image: url("../../assets/image/bg16.png");
        background-size: cover;
        margin-left: -140px;
        margin-top: -100px;
        backdrop-filter: blur(10px);

        .responsibility-content {
          height: 320px;
          overflow-y: auto;
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 20px;
          color: #666666;
          line-height: 30px;
          white-space: pre-wrap;
        }

        ::-webkit-scrollbar {
          width: 3px;
          height: 51px;
        }

        /* 定义滚动条轨道 */
        ::-webkit-scrollbar-track {
          //   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
          border-radius: 2px;
          background-color: #fff;
        }

        /* 滑块 */
        ::-webkit-scrollbar-thumb {
          border-radius: 2px;
          -webkit-box-shadow: #1566d4;
          background-color: #1566d4;
        }
      }
    }

    .sm-responsibility-line {
      .responsibility-img {
        width: 100%;
        z-index: 2;
        position: relative;

        img {
          width: 100%;
          min-height: 423px;
        }
      }

      .responsibility-info {
        min-width: 600px;
        max-width: 100%;
        width: 680px;
        height: 468px;
        z-index: 4;
        position: relative;
        margin: 0 auto;
        // margin-left: 0;
        margin-top: -70px;
        overflow-y: auto;

        .responsibility-content {
          height: 326px;
          min-height: 326px;
          overflow: auto;
        }
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 1200px) {
  // 中心简介
  .intro-area {
    .page-middle-content-row {
      padding: 0;
    }
    .sm-intro-col {
      .intro-img {
        // width: 100%;
        // height: 423px;
        // max-width: 750px;
        min-height: 423px;
        img {
          width: 100%;
          // height: 423px;
          min-height: 423px;
          // max-width: 750px;
          object-fit: cover;
        }
      }
      .intro-info {
        width: calc(100% - 48px) !important;
        // max-width: 702px;
      }
      .intro-line {
        .intro-btn {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .intro-btn-item {
            padding: 20px 20px;
            margin: 0;
            text-align: center;
            font-size: 26px;
            min-width: 0;
            // min-width: 317px;
          }
        }
        .intro-content {
          font-size: 24px;
        }
      }
    }
  }
  //  领导介绍
  .leader-area {
    .leader-box {
      .leader-item {
        height: 341px;
        .leader-name {
          font-size: 26px;
        }
        .leader-info {
          > div {
            font-size: 24px;
          }
        }
        .leader-img {
          width: 170px;
          height: 170px;
          img {
            width: 100%;
            height: 170px;
          }
        }
        .leader-content {
          width: 280px;
          height: 280px;
        }
      }
    }
  }
  .pla-leader-item {
    width: 100%;
    min-height: 341px!important;
    margin-bottom: 15px;
  }
  /deep/.el-dialog {
    width: cacl(100 - 48px);
    max-width: 702px;
  }
  // 业务范围
  .service-area {
    .service-swiper-item {
      //       background: rgba(255,255,255,0);
      box-shadow: 0px 0px 30px 0px rgba(10, 49, 128, 0.1);
      backdrop-filter: blur(3px);
      .service-swiper-left {
        // width: 88px;
        top: 450px;
        left: -65px;
      }
      .service-swiper-right {
        // width: 88px;
        top: 450px;
        right: -65px;
      }
    }
  }
  // 发展规划
  .planning-area {
    .planning-box {
      .planning-img {
        width: 100%;
        max-width: 702px;
        margin: 0 auto;
        margin-bottom: 20px;
        img {
          height: 396px;
        }
      }
      .planning-info-content {
        font-size: 24px;
      }
      .planning-item-line {
        .planning-item {
          padding: 0 5px;
          .planning-item-title {
            > span:first-of-type {
              font-size: 36px;
            }
            > span:last-of-type {
              font-size: 20px;
            }
          }
          .planning-desc {
            font-size: 24px;
          }
        }
      }
      // .{
      //   font-size: 36px;
      // }
    }
  }
  // 荣誉与成就
  .honor-area {
    .page-model-title-line {
      margin-bottom: 30px;
    }
  }
  // 社会责任
  .responsibility-area {
    .page-middle-content-row {
      padding: 0;
      // 423px
    }
    .responsibility-img {
      width: 100%;
      margin: 0 auto;
      max-width: 750px;
      img {
        width: 100%;
        height: 423px;
      }
    }
    .responsibility-info {
      width: calc(100% - 48px);
      max-width: 702px;
      .responsibility-content {
        font-size: 24px !important;
      }
    }
  }
}
</style>